import { FC, useState, useEffect, useRef } from "react";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";

interface FilterConnectionsProps {
  categories: string[];
  onCategorySelect: (subject: string) => void;
}

export const FilterConnections: FC<FilterConnectionsProps> = ({
  categories,
  onCategorySelect,
}) => {
  const [selected, setSelected] = useState<string>(
    categories.length > 0 ? categories[0] : "",
  );

  // Ref to track the first render
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      // Skip the effect on the first render
      isFirstRender.current = false;
      return;
    }
    // Call the callback on subsequent updates
    onCategorySelect(selected);
  }, [selected, onCategorySelect]);

  return (
    <div className="absolute top-6 md:top-8 right-2 md:right-4 border-[#ffffff80] border-2 rounded-[24px] text-white bg-black backdrop--tinted flex-col px-2 text-sm flex sort-dropdown active">
      <div className="flex h-10 items-center">
        <span className="d-icon h-full text-base mr-2 d-filter-vertical flex items-center"></span>
        <span className="flex items-center justify-center expanding-text">
          Filter connecties
        </span>
      </div>
      <Listbox value={selected} onChange={setSelected}>
        {({ open }) => (
          <>
            <div className="flex items-center h-10 p-2 mb-2 rounded cursor-pointer border border-[#ffffff80] whitespace-nowrap overflow-hidden">
              <ListboxButton className="flex items-center">
                <span className="flex-grow text-left truncate">
                  {selected || "Select Category"}
                </span>
                <span
                  className={`d-icon d-arrowhead-down flex items-center text-white ml-2 flex-shrink-0 ${open ? "-scale-y-100" : ""}`}
                ></span>
              </ListboxButton>
            </div>
            <ListboxOptions className="absolute rounded border-2 border-[#ffffff80] text-white top-full mt-1 py-2 w-full left-0">
              {categories.map((category) => (
                <ListboxOption
                  key={category}
                  value={category}
                  className={({ focus }) =>
                    `px-2 py-1 hover:bg-opacity-20 hover:bg-white cursor-pointer ${
                      focus ? "" : ""
                    }`
                  }
                >
                  {category}
                </ListboxOption>
              ))}
            </ListboxOptions>
          </>
        )}
      </Listbox>
    </div>
  );
};
